var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"grey lighten-5 my-0 px-0 py-0",attrs:{"fluid":""}},[_c('QMyClientsSubmenu'),_c('FIFForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }